exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".labeled-link{display:flex;flex-flow:row wrap;padding-bottom:5px}.labeled-link .data-label{color:#aaa;margin-right:10px}.labeled-link .data-key .smart-form-link{line-height:1;padding-bottom:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/labeled-smart-form-link/labeled-smart-form-link.scss
// module id = 5266
// module chunks = 0